import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard, SiteHeaderProvider } from '@shapeable/ui';
// import { SiteHeaderLayout } from '../entities/site-header-layout';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      width: 100%;
      font-weight: 500;
      font-family: ${theme.FONT('heading')};
      margin-bottom: ${theme.UNIT(8)};
      font-size: 2.5em;
      letter-spacing: -1px;
    }

    /* For site header nav (menu-link-item) jump links */
    [id] {
      scroll-margin-top: 100px;
    }
  `,
  tablet: css`
    .shp--banner-titles {
      width: 100%;
    }

    .shp--page-layout-standard__title {
      font-size: 4.5em;
    }
  `,
  desktop: css`
    .shp--page-layout-standard__title {
      font-size: 5.5em;
    }
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutDefault: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <SiteHeaderProvider value={{
      variant: 'default', // setting variant to overlay keeps the login utility button icon and text white...
      boundary: 'content'
    }}>
    <My.Layout 
      className={className}
      entity={entity}
      slices={slices}
      headerProps={{ 
        aspectRatio: { base: 16/9, desktop: 21/9 },
        showOverlayGradient: true,
        fadeColor: '#0000000', 
        overlayColor: '#00000011',
        // backgroundColor: '#0000000',
        useBackgroundColor: true }} 
    />
    </SiteHeaderProvider>
  )
};


